<template>
  <div
    v-if="opened"
    class="AwAlert px-4 py-2"
    :class="{
      'bg-ambi-green-success': type == 'success',
      'bg-ambi-orange': type == 'error'
    }"
  >
    <div class="flex items-center">
      <div class="text-p2 font-america-m text-white text-center flex-1">
        <slot>Text ...</slot>
      </div>
      <div class="ml-auto pl-3 flex-shrink-0" v-if="dismisable">
        <div class="-mx-1.5 -my-1.5">
          <button @click="close" type="button" class="inline-flex rounded-md p-1.5 text-white">
            <span class="sr-only">Dismiss</span>
            <aw-icon icon="close" class="h-7 w-7" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success',
      validate: value => {
        return value.includes('success', 'error', 'info', 'warning')
      }
    },
    dismisable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      opened: true
    }
  },
  methods: {
    close() {
      this.opened = false
    }
  }
}
</script>

<style lang="scss" scoped>
:slotted(a) {
  @apply underline;
}
</style>
